import Checkbox from "../Input/Checkbox";

export default function SummaryItem({
  isDisabled = false,
  headerText,
  subText,
  isChecked = false,
  setIsChecked,
}) {
  return (
    <div className="summary-item">
      <div
        className="summary-item-container"
        onClick={() => {
          setIsChecked(!isChecked);
        }}>
        <Checkbox
          disabled={isDisabled}
          isChecked={isChecked}
          setIsChecked={setIsChecked}
          isSmall
        />
        <label className="summary-item-label-header">{headerText}</label>
      </div>
      <small>{subText}</small>
    </div>
  );
}
